const VIEWBOX_REGEX = /viewBox="([^"]*)"/
const SVG_REGEX = /(<svg[^>]*>|<\/svg>)/g
const FILL_REGEX = /fill="[^"]*"/g

export function iconLoader(source) {
  const finalSource = source.replace(FILL_REGEX, fill => {
    return fill.includes('#FFF') ? 'fill="currentColor"' : ''
  })

  // Issue with ESLint recognizing this as needing an object destructure
  // eslint-disable-next-line prefer-destructuring
  const viewBox = VIEWBOX_REGEX.exec(finalSource)[1]
  return {
    viewBox,
    body: finalSource.replace(SVG_REGEX, ''),
  }
}



// WEBPACK FOOTER //
// ./src/utils/svg.js